import request from '@/utils/request'

function QUERY( {key, params}) {
  let url
  if(key=='GetSetData'){
    url = '/h5/SappSetting/index'
  }

  if(key=='GetSetList'){
    url = '/h5/SappSetting/getBossShopList'
  }

  if(key=='ChangeStroe'){
    url = '/h5/SappSetting/changeShop'
  }

  
  if (typeof params == 'object') {
    params['version'] = 'MINI'
  } else {
    params = { version: 'MINI' }
  }
  return request({
    url,
    method: 'post',
    params
  })
}

export default QUERY;